import { render, staticRenderFns } from "./StudentEditTabEmails.vue?vue&type=template&id=832d5784&scoped=true&"
import script from "./StudentEditTabEmails.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabEmails.vue?vue&type=script&lang=js&"
import style0 from "./StudentEditTabEmails.vue?vue&type=style&index=0&id=832d5784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832d5784",
  null
  
)

export default component.exports